import { Component } from "@angular/core";
import { CTableCell } from "../../../../core/ui/c-table/c-table-config";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { DuplicateConfirmPopupComponent } from "../duplicate-confirm-popup/duplicate-confirm-popup.component";
import { ReportPopupComponent } from "../report-popup/report-popup.component";
import { DIGITAL_MEMORY_LOG_CONSTANTS } from "../../constants/digital-memory-log.constants";
import { isDigitalMemoryLogExpired } from "../../utils/digital-memory-log.utils";

@Component({
  selector: "app-digital-memory-log-list-action-component",
  templateUrl: "./digital-log-action-col.component.html",
})
export class DigitalLogActionColComponent implements CTableCell {
  extraData;
  row;
  column;
  readonly expiredTooltip = DIGITAL_MEMORY_LOG_CONSTANTS.MESSAGES.EXPIRED_TOOLTIP;

  constructor(private modalService: NgbModal) {}

  isExpired(entity: any): boolean {
    return isDigitalMemoryLogExpired(entity);
  }

  openDuplicateConfirm(entity: any) {
    const modalRef = this.modalService.open(DuplicateConfirmPopupComponent, {
      centered: true,
      size: "lg",
      backdrop: true,
      keyboard: true,
    });
    
    modalRef.componentInstance.digitalLogId = entity.id;
    modalRef.componentInstance.digitalLogName = entity.name;

    // Handle modal result
    modalRef.result.then(
      (result) => {
        if (result === "duplicated" && this.extraData.onDuplicateSuccess) {
          this.extraData.onDuplicateSuccess(entity);
        }
      },
      (reason) => {
      }
    );
  }

  openReportPopup(entity: any) {
    const modalRef = this.modalService.open(ReportPopupComponent, {
      centered: true,
      size: "lg",
      backdrop: true,
      keyboard: true,
    });
    
    modalRef.componentInstance.digitalLogId = entity.id;
    modalRef.componentInstance.digitalLogName = entity.name;

    // Handle modal result
    modalRef.result.then(
      (result) => {
        // Handle any result if needed
      },
      (reason) => {
        // Handle dismissal
      }
    );
  }
}
